// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---content-pages-404-js": () => import("./../../../content/pages/404.js" /* webpackChunkName: "component---content-pages-404-js" */),
  "component---content-pages-index-js": () => import("./../../../content/pages/index.js" /* webpackChunkName: "component---content-pages-index-js" */),
  "component---content-pages-mcp-server-js": () => import("./../../../content/pages/mcp-server.js" /* webpackChunkName: "component---content-pages-mcp-server-js" */),
  "component---src-templates-api-js": () => import("./../../../src/templates/api.js" /* webpackChunkName: "component---src-templates-api-js" */)
}

